import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["roleOption", "userIdsOption", "scheduleOption"]

  toggleTargetOptions(event) {
    const value = event.target.value

    this.roleOptionTarget.style.display = value === "by_role" ? "flex" : "none"
    this.userIdsOptionTarget.style.display = value === "by_user_ids" ? "flex" : "none"
  }

  toggleScheduleOption(event) {
    const value = event.target.value

    this.scheduleOptionTarget.style.display = value === "scheduled" ? "flex" : "none"
  }
}
